import turfBuffer from '@turf/buffer';
import turfMask from '@turf/mask';
import turfSimplify from '@turf/simplify';
import turfTesselate from '@turf/tesselate';
import { Feature, FeatureCollection, Point, Polygon as GeoJSONPolygon } from 'geojson';
import transform from 'geojson-transformer';
import { findList,findListInfo, IRegion, updatePath } from '../../api/operation/region';
import SingletonEventEmitterClass from '../SingletonEventEmitterClass';
import Polygon from './Polygon';

export default class RegionsLoader extends SingletonEventEmitterClass {
  private _regions: IRegion[] = [];
  private _regionInfo?: IRegion;
  private _editingRegion?: IRegion;
  private _editingRegionHash?: string;
  private _editor?: Polygon;

  public get regions() {
    return this._regions;
  }

  public get geojson(): FeatureCollection<GeoJSONPolygon> {
    return {
      type: 'FeatureCollection',
      features: this._regions.filter(region => region !== this._editingRegion).map<Feature<GeoJSONPolygon>>(region => {
        return {
          type: 'Feature',
          geometry: region.geometry!,
          properties: {
            info: {
              ...region, layerType: 'region',
            },
          },
        };
      }),
    };
  }

  public get geojsonEditor(): FeatureCollection<Point> {
    if (!this._editor) {
      return {
        type: 'FeatureCollection',
        features: [],
      };
    }
    return this._editor.geojsonEditor;
  }

  public get geojsonBuffer(): FeatureCollection<GeoJSONPolygon> {
    if (!this._editor) {
      return {
        type: 'FeatureCollection',
        features: [],
      };
    }
    const polygon = this._editor.geojsonPolygon;
    return turfTesselate(turfMask(polygon, turfSimplify(turfBuffer(polygon, 2), {
      tolerance: 0.01,
      mutate: true,
    }))) as FeatureCollection<GeoJSONPolygon>;
  }

  public get editor() {
    return this._editor;
  }

  public get geojsonEditingRegion(): Feature<GeoJSONPolygon> {
    if (!this._editor) {
      return {
        type: 'Feature',
        geometry: {
          type: 'Polygon',
          coordinates: [[[]]],
        },
        properties: {},
      };
    }
    return this._editor.geojsonPolygon;
  }

  public onMapLoad() {
    this._findRegionsFromRemote();
    // this._showRegionInfo("1704211741012");
  }

  public startEditing(region: IRegion) {
    if (this._editingRegion) {
      return;
    }
    const points = region.geometry!.coordinates[0];
    this._editingRegion = region;
    this._editor = new Polygon(points as ILngLat[], 0.0005);
    this._editingRegionHash = this._editor.hash;
    this._editor.on('updated', () => {
      this._triggerEditorUpdated();
    });
    this._triggerEditorUpdated();
  }

  public finishEditing() {
    if (this._editingRegion && this._editingRegionHash !== this._editor!.hash) {
      const region = this._editingRegion;
      updatePath(region._id, this._editor!.points).then(({ data }) => {
        if (data) {
          region.geometry = data.geometry;
          this._triggerUpdated();
        }
      }).catch(error => console.error(error.message));
    }
    this.cancelEditing();
  }

  public cancelEditing() {
    this._editingRegion = undefined;
    this._editor = undefined;
    this._triggerEditorUpdated();
  }

  private _triggerUpdated() {
    this.emit('updated');
  }

  private _triggerEditorUpdated() {
    this.emit('editor_updated');
    this._triggerUpdated();
  }

  private async _findRegionsFromRemote() {
    const { data } = await findList();
    this._regions = data.items.filter(region =>{return region.geometry || region.path;}).map(region => {
      region.geometry = region.geometry || transform(region.path, 'gcj02', 'wgs84');
      return region;
    });
    this._triggerUpdated();
  }

  //展示大区详情
  public async _showRegionInfo(id:string) {
    const { data } = await findListInfo(id);
    this._regionInfo = data || undefined;
    this._triggerUpdated();
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/loaders/RegionsLoader.ts